
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/account_settings/notifications",
      function () {
        return require("private-next-pages/account_settings/notifications.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/account_settings/notifications"])
      });
    }
  